import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiWoerdenSchipholPage() {
  return (
    <CityAirportTemplate
      city="Woerden"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={65.00}
      distance="55 km"
      duration="45-50 minuten"
    />
  );
}
